import { business } from "@/config/business";

// All WhatsApp URLs are generated programmatically. The number is never hard-coded.
export const buildWhatsAppUrl = (message) =>
  `https://wa.me/${business.whatsapp}?text=${encodeURIComponent(message)}`;

export const buildCallUrl = () => `tel:${business.phone}`;

const rupee = (n) => `₹${new Intl.NumberFormat("en-IN").format(n)}`;

export const generalMessage = () =>
  `Hi ${business.businessName},\n\nI found you on your website and would like some help.`;

export const productMessage = (product) =>
  `Hi ${business.businessName},\n\nI'm interested in ${product.brandName} ${product.model} (${product.storage}${product.color ? `, ${product.color}` : ""}).\n\nPrice shown: ${rupee(product.price)}\n\nIs it currently available?`;

export const repairMessage = ({ device, problem }) =>
  `Hi ${business.businessName},\n\nI need help repairing my ${device || "phone"}.\n\nProblem: ${problem || "—"}\n\nPlease let me know the next steps.`;

export const repairServiceMessage = (serviceName) =>
  `Hi ${business.businessName},\n\nI need help with: ${serviceName}.\n\nPlease let me know the next steps.`;

export const sellMessage = (data = {}) => {
  const lines = [
    `Hi ${business.businessName},`,
    "",
    "I want to sell my phone.",
    "",
    data.brand && `Brand: ${data.brand}`,
    data.model && `Model: ${data.model}`,
    data.storage && `Storage: ${data.storage}`,
    data.condition && `Condition: ${data.condition}`,
    data.batteryHealth && `Battery Health: ${data.batteryHealth}`,
    data.age && `Phone Age: ${data.age}`,
    data.bill && `Original Bill: ${data.bill}`,
    data.accessories && `Accessories: ${data.accessories}`,
    data.description && `Notes: ${data.description}`,
    data.name && `Name: ${data.name}`,
    data.phone && `Phone: ${data.phone}`,
    "",
    "Please let me know the approximate value.",
  ].filter(Boolean);
  return lines.join("\n");
};

export const contactMessage = (data = {}) => {
  const lines = [
    `Hi ${business.businessName},`,
    "",
    data.message || "I'd like to get in touch.",
    "",
    data.name && `Name: ${data.name}`,
    data.phone && `Phone: ${data.phone}`,
  ].filter(Boolean);
  return lines.join("\n");
};
